import React, { useContext } from 'react';
import { ManageAccount12MonthsContext, ManageAccount12MonthsProvider } from './dash_12MServiceProvider';
import { CircularProgress, Grid } from '@material-ui/core';
import Dashboard12MTable from './dashboard12M-Table';

const Screen = (props) => {
    const { state, dashboardIDHandler, dashboardID } = useContext(ManageAccount12MonthsContext);
    return (
        <div style={{ padding: 10 }}>
            {state.screenLoader ? (
                <Grid container alignItems="center" justifyContent="center" style={{ height: '50vh' }}>
                    <Grid item>
                        <div>
                            <CircularProgress />
                        </div>
                        <div>Please wait while we are loading your data...</div>
                    </Grid>
                </Grid>
            ) : (
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <div
                            style={{
                                display: 'grid',
                                gridTemplateColumns: 'repeat(auto-fit, minmax(170px, 1fr))',
                                gap: '7px'
                            }}
                        >
                            {state.dashboardMenus.map((menu) => (
                                <div
                                    onClick={() => dashboardIDHandler(menu.id)}
                                    style={{
                                        padding: '4px 8px',
                                        border: '2px solid #A3D1C6',
                                        borderRadius: 4,
                                        backgroundColor: dashboardID === menu.id ? '#3D8D7A' : 'white',
                                        cursor: 'pointer',
                                        minWidth: 100,
                                        fontSize: 12,
                                        textAlign: 'center',
                                        fontWeight: dashboardID === menu.id ? 600 : 500,
                                        // transition: 'all 0.2s ease',
                                        color: dashboardID === menu.id ? 'white' : '#444'
                                    }}
                                    onMouseEnter={(e) => {
                                        if (dashboardID !== menu.id) e.currentTarget.style.backgroundColor = '#A3D1C6';
                                    }}
                                    onMouseLeave={(e) => {
                                        if (dashboardID !== menu.id) e.currentTarget.style.backgroundColor = '#fff';
                                    }}
                                >
                                    {menu.name}
                                </div>
                            ))}
                        </div>
                    </Grid>

                    <Grid item xs={12}>
                        <Dashboard12MTable />
                    </Grid>
                </Grid>
            )}
        </div>
    );
};

const ManageAccount12MScreen = (props) => {
    return (
        <ManageAccount12MonthsProvider {...props}>
            <Screen {...props} />
        </ManageAccount12MonthsProvider>
    );
};
export default ManageAccount12MScreen;
